import { makeStyles } from "@material-ui/core/styles";

export const toolstyles = makeStyles((theme) => ({
  mentorTip: {
    "& .header .mentorTitle": {
      fontWeight: 400,
    },
  },
  card: {
    padding: "15px",
  },
  title: {
    fontSize: theme.typography.pxToRem(30),
    fontWeight: 600,
    lineHeight: 1,
    fontFamily: "Inter",
    color: "#0F172A",
    marginBottom: "15px",
  },
}));
